






















import { Component, Vue } from "vue-property-decorator";

import LanguageModule from "../store/modules/languageModule";
import { getModule } from "vuex-module-decorators";

const languageStore = getModule(LanguageModule);

@Component({})
export default class Navigation extends Vue {
  private get visible() {
    return this.$route.path != "/";
  }

  private onPrevious() {
    // go back by one record, the same as history.back()
    this.$router.go(-1);
  }

  private get mainDisabled() {
    return (
      this.$route.path === "/" || this.$route.path === `/${this.language}/main`
    );
  }

  private get previousDisabled() {
    const paths = ["/", "/main", "/map", "/places", "/chronology"];

    return !paths.every(path => this.$route.path != `/${this.language}${path}`);
  }

  private get language() {
    return languageStore.language;
  }
}
